module.exports = __webpack_public_path__ + "static/architecture-6149731fc9f1dc2d5e6dc8c7ddbe87d3.png";